import Leftmenu from '../element/leftmenu';
import Header from '../element/header';
import React, {Component} from "react";
import {DatePicker, Popconfirm, Button, Breadcrumb, PageHeader, List, Avatar, Popover, Layout} from 'antd';
import {DeleteOutlined, DownloadOutlined, EditOutlined, UserOutlined, WechatOutlined} from '@ant-design/icons';
import 'antd/dist/antd.css';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Card, Col, Row, Statistic, Typography, Space, Table, Tag } from 'antd';
import PageBreadcrumb from "../element/pagebreadcrumb";
import Datasellstaff from "../element/datasellstaff";
import Datasellbottom from "../element/datasellbottom";
import Datasellkind from "../element/datasellkind";
import Datasellfunnel from "../element/datasellfunnel";
import Datasellpat from "../element/datasellpat";
import moment from "moment";
import DataBuildsellfunnel from "../element/databuildsellfunnel";
import DataBuildsellbottom from "../element/databuildsellbottom";
import DataBuildsellpat from "../element/databuildsellpat";
const { Title,Text } = Typography;
const { Content } = Layout;
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key'
    },
    {
        title: '未扎账单位',
        dataIndex: 'name',
        key: 'name'
    },
    {
        title: '账期',
        dataIndex: 'time',
        key: 'time'
    }
];

class HomeData extends Component{

    constructor(props) {
        super(props);
        var day = moment().format('DD')/*
        var month = moment().subtract(1, "months")
        if(day >= 26){
            month = moment()
        }*/
        var month = moment()
        this.state = {
            list: [],
            sum: 0,
            num: 0,
            client: 0,
            month: month,
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD') + ' 23:59:59'
        };
    }

    componentDidMount(){
        fetch("https://pd.pokemonbye.com:8081/api/getweightdatatypebydate?start=" + this.state.start + '&end=' + this.state.end)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data
                    var sum = 0
                    var num = 0
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1;
                            sum += parseFloat(array[i].sum)
                            num += parseFloat(array[i].num)
                        }
                        this.setState({
                            isLoaded: true,
                            sum: sum,
                            num: num
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data
                    var client = 0
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1;
                            client ++
                        }
                        this.setState({
                            isLoaded: true,
                            client: client
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientman")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data
                    var man = 0
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1;
                            man ++
                        }
                        this.setState({
                            isLoaded: true,
                            man: man
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclient")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    fetch("https://pd.pokemonbye.com:8084/api/getsellfundlikeintrobydate?intro=结算&month=" + this.state.month.format('YYYY-MM') + '-01')
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let list = result.data;
                                const diff = array.filter(obj1 => !list.some(obj2 => obj1.name === obj2.fund_client));
                                for (let i = 0; i < diff.length; i++) {

                                    diff[i].key = i + 1
                                    diff[i].time = this.state.month.format('YYYY-MM')
                                }
                                this.setState({
                                    isLoaded: true,
                                    list: diff
                                });
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                                this.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        )
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    render() {
        return (

            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <Content className="site-layout-background">
                        <div className="site-card-border-less-wrapper">
                            <PageHeader
                                ghost={false}
                                title="数据概况"
                            >
                            </PageHeader>
                            <Title level={5}>销售情况概览</Title>

                            <div className="site-statistic-demo-card">
                                <Row gutter={[24, 24]}>
                                    <Col span={6}>
                                        <Card hoverable>
                                            <Statistic
                                                title="销售量"
                                                value={this.state.sum}
                                                precision={2}
                                                valueStyle={{
                                                    color: '#cf1322',
                                                }}
                                                prefix={<ArrowUpOutlined />}
                                                suffix="吨"
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={6}>
                                        <Card hoverable>
                                            <Statistic
                                                title="提货单量"
                                                value={this.state.num}
                                                valueStyle={{
                                                    color: '#cf1322',
                                                }}
                                                prefix={<ArrowUpOutlined />}
                                                suffix="单"
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={6}>
                                        <Card hoverable>
                                            <Statistic
                                                title="注册客户"
                                                value={this.state.client}
                                                precision={0}
                                                valueStyle={{
                                                    color: '#cf1322',
                                                }}
                                                prefix={<ArrowUpOutlined />}
                                                suffix="个"
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={6}>
                                        <Card hoverable>
                                            <Statistic
                                                title="销售人员"
                                                value={this.state.man}
                                                precision={0}
                                                valueStyle={{
                                                    color: '#3f8600',
                                                }}
                                                prefix={<ArrowDownOutlined />}
                                                suffix="人"
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                                <Space size={1000}>
                                    <Title level={5}>销售同比曲线</Title>
                                    <Title level={5}>待扎账单位</Title>
                                </Space>
                                <Row gutter={24}>
                                    <Col span={16}>
                                        <Card hoverable>
                                            <DataBuildsellbottom />
                                        </Card>
                                    </Col>
                                    <Col span={8}>
                                        <Card hoverable>
                                            <Table columns={columns} dataSource={this.state.list} pagination={false} bordered scroll={{
                                                y: 200,
                                            }} size={'small'}/>
                                        </Card>
                                    </Col>
                                </Row>
                                <Space size={450}>
                                    <Title level={5}>合作客户排名</Title>
                                    <Title level={5}>销售人员排名</Title>
                                </Space>
                                <Row gutter={24}>
                                    <Col span={8}>
                                        <Card hoverable>
                                            <DataBuildsellfunnel />
                                        </Card>
                                    </Col>
                                    <Col span={16}>
                                        <Card hoverable>
                                            <DataBuildsellpat />
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Content>
                </div>
            </div>
        )
    }
}

export default HomeData;
